import React from 'react';
import { observer } from 'mobx-react';

import { constants } from '../../../config';
import { ScreenStore } from '../../../stores/ScreenStore';
import { HomeNavbar } from '../../../common/home-navbar';
import { SessionStore } from '../../../stores/SessionStore';
import { AddressStore } from '../../../stores/AddressStore';
import { USER_TYPES } from '../../../models/User';
import { AppRedirect, routeNaming, AppLink } from '../../../routes';
import { MyAccountMenu } from '../my-account-menu';
import { Footer } from '../../../common/footer';
import { Spinner } from '../../../common/spinner';
import { SecondaryButton } from '../../../common/secondary-button';
import { AddressCard } from '../../../common/address-card';
import styles from './MyAddresses.css';
import { BUTTON_TYPES } from '../../../common/address-card/AddressCard';
import { isV2ActiveFor, FeatureV2Selector } from '../../../common/feature-v2-selector';
import { SEO } from '../../../common/seo';

const SCREENS = {
  SHOW_ADDRESSES: 'showAddresses',
  NEW_ADDRESS: 'newAddress',
  EDIT_ADDRESS: 'editAddress',
};

class MyAddresses extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      actualScreen: SCREENS.SHOW_ADDRESSES,
      address: null,
    };

    this._toggleCancel = this._toggleCancel.bind(this);
    this._handleNewAddressClick = this._handleNewAddressClick.bind(this);
    this._handleAddressSubmition = this._handleAddressSubmition.bind(this);
    this._handleEditClick = this._handleEditClick.bind(this);
  }

  componentDidMount() {
    if (isV2ActiveFor('addressv2-users-enabled')) {
      AddressStore.getUserAddressesV2();
    } else {
      AddressStore.getUserAddresses();
    }
  }

  componentDidUpdate(_, prevState) {
    // If the screen changes, scroll to the top of it
    if (prevState.actualScreen !== this.state.actualScreen) {
      window.scrollTo(0, 0);
    }
  }

  _handleNewAddressClick(event) {
    event.preventDefault();
    this.setState({
      actualScreen: SCREENS.NEW_ADDRESS,
    });
  }

  _toggleCancel(event) {
    event.preventDefault();
    this.setState({
      actualScreen: SCREENS.SHOW_ADDRESSES,
    });
  }

  _handleAddressSubmition() {
    this.setState({
      actualScreen: SCREENS.SHOW_ADDRESSES,
    });
  }

  _handleEditClick(address) {
    this.setState({
      actualScreen: SCREENS.EDIT_ADDRESS,
      address,
    });
  }

  render() {
    if (!SessionStore.loggedIn) {
      return (
        <AppRedirect routeName={routeNaming.HOME} />
      );
    }
    const mobileVersion = ScreenStore.screenWidth <= constants.breakpoints.extraSmallMaxWidth;

    const dataLoaded = AddressStore.addresses !== null;

    const isShowingData = this.state.actualScreen === SCREENS.SHOW_ADDRESSES;
    const isCreatingData = this.state.actualScreen === SCREENS.NEW_ADDRESS;
    const isEditingData = this.state.actualScreen === SCREENS.EDIT_ADDRESS;

    return (
      <div className={styles.container}>
        <SEO
          title="Mis direcciones"
          type="website"
        />
        <HomeNavbar />
        <div className={styles.mainContent}>
          {
            !mobileVersion &&
            <div className={styles.titleContainer}>
              <h1 className={styles.title}>Mi Cuenta</h1>
              <h2 className={styles.subtitle}>
                <span>Hola, </span>
                {SessionStore.user.type === USER_TYPES.COMPANY ?
                  SessionStore.user.fictitiousName :
                  SessionStore.user.names}
                !
              </h2>
            </div>
          }
          {
            mobileVersion &&
            <p className={styles.breadcrumb}>
              <AppLink
                className={styles.breadcrumb}
                routeName={routeNaming.MY_ACCOUNT_MENU_MOBILE}
              >
                Mi Cuenta
              </AppLink>
              <span> &gt; Mis direcciones</span>
            </p>
          }
          <div className={styles.content}>
            {
              !mobileVersion && <MyAccountMenu indexSelectedItem={1} />
            }
            <div className={styles.bodyContainer}>
              <div className={styles.headerContainer}>
                <h2 className={styles.header}>
                  { isShowingData && 'Mis direcciones' }
                  { isCreatingData && 'Nueva dirección' }
                  { isEditingData && 'Editar dirección' }
                </h2>
                {
                  !isShowingData &&
                  <button className={styles.cancelButton} onClick={this._toggleCancel}>
                    CANCELAR
                  </button>
                }
              </div>
              <div className={styles.addressContainer}>
                <div className={styles.addressContent}>
                  {
                    isShowingData && !dataLoaded &&
                    <Spinner className={styles.spinner} />
                  }
                  {
                    isShowingData && dataLoaded &&
                    AddressStore.addresses.map(address => (
                      <AddressCard
                        address={address}
                        className={styles.addressCard}
                        key={address.id}
                        buttonType={BUTTON_TYPES.EDIT}
                        onButtonClick={this._handleEditClick}
                      />
                    ))
                  }
                  {
                    isCreatingData &&
                    <div className={styles.addressFormContainer}>
                      <FeatureV2Selector
                        feature="addressv2-users-enabled"
                        component="address-form"
                        collapseEarly
                        withoutTitle
                        onAddressCreation={this._handleAddressSubmition}
                      />
                    </div>
                  }
                  {
                    isEditingData &&
                    <div className={styles.addressFormContainer}>
                      <FeatureV2Selector
                        feature="addressv2-users-enabled"
                        component="address-form"
                        collapseEarly
                        withoutTitle
                        onAddressEdition={this._handleAddressSubmition}
                        address={this.state.address}
                      />
                    </div>
                  }
                </div>
                {
                  isShowingData && dataLoaded &&
                  <SecondaryButton
                    className={styles.newAddressButton}
                    onClick={this._handleNewAddressClick}
                  >
                    Nueva
                  </SecondaryButton>
                }
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const ObservedMyAddresses = observer(MyAddresses);

export { ObservedMyAddresses as MyAddresses };



// WEBPACK FOOTER //
// ./src/pages/my-account/my-addresses/MyAddresses.jsx